module.exports = __webpack_public_path__ + "img/domestic-2008-xuejun.44538336.jpg";